<!-- tab导航和搜索 -->
<template>
  <div class="contents">
    <img
      src="../assets/images/toupiao/ckline.png"
      alt=""
      srcset=""
      class="ckline"
    />
    <div class="component-tab"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ComponentTab",
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "userinfo", // 用户信息
      "headerNavIndex" // 当前激活的导航菜单的下标
    ])
  },
  mounted() {
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    /**
     * ##########################################################################################
     * @description 头像下拉菜单点击事件
     * @param {String} command : dropdown-item 的指令
     * ##########################################################################################
     */

    handleCommand(command) {
      console.log("点击了菜单:", command);
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style lang="scss" scoped>
/* 参考线 */
.ckline {
  height: 12px;
  width: 100%;
  position: absolute;
  top: 890px;
}
</style>



// WEBPACK FOOTER //
// src/components/tab.vue